import { Link } from "react-router-dom";

const LandingFooter = () => {
  return (
    <footer className="border-t border-black/10 py-12">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mb-12 grid gap-8 md:grid-cols-5">
          <div className="md:col-span-2">
            <span className="mb-4 block text-xl font-bold text-black">
              Bite Balance
            </span>
            <p className="max-w-xs text-sm text-black/50">
              AI-powered nutrition and fitness tracking for optimal gut health
              and metabolic wellness.
            </p>
          </div>
          <div>
            <h4 className="mb-4 font-semibold text-black">Product</h4>
            <ul className="space-y-3 text-sm text-black/50">
              <li>
                <Link
                  to="/landing/features"
                  className="transition-colors hover:text-black"
                >
                  Features
                </Link>
              </li>
              <li>
                <Link
                  to="/landing/pricing"
                  className="transition-colors hover:text-black"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/landing/integrations"
                  className="transition-colors hover:text-black"
                >
                  Integrations
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 font-semibold text-black">Company</h4>
            <ul className="space-y-3 text-sm text-black/50">
              <li>
                <Link
                  to="/landing/about"
                  className="transition-colors hover:text-black"
                >
                  About
                </Link>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-black">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-black">
                  Careers
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 font-semibold text-black">Legal</h4>
            <ul className="space-y-3 text-sm text-black/50">
              <li>
                <a href="#" className="transition-colors hover:text-black">
                  Privacy
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-black">
                  Terms
                </a>
              </li>
              <li>
                <a href="#" className="transition-colors hover:text-black">
                  Security
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-black/10 pt-8 text-center text-sm text-black/40">
          <p>
            © {new Date().getFullYear()} Bite Balance. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
